var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.366 728C37.302 728 8 691.458 8 655.478C8 619.498 37.302 590.265 73.366 590.265H180.382L572.382 297H726.634C762.698 297 792 326.185 792 362.164C792 398.144 762.698 436.53 726.634 436.53H619.618L227.023 728H73.366Z",
    fill: "#062134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.5 219C367.541 219 400 186.093 400 145.5C400 104.907 367.541 72 327.5 72C287.459 72 255 104.907 255 145.5C255 186.093 287.459 219 327.5 219Z",
    fill: "#062134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258 340.26C258 301.489 289.186 270 327.573 270C358.127 270 383.815 290.074 393.059 317.824C395.492 324.909 397 332.437 397 340.26V383.5L258 493V340.26Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMall);
export default __webpack_public_path__ + "static/media/ico_mall.93582e6d5aaf091d25a6428a31f8ffd9.svg";
export { ForwardRef as ReactComponent };